import React, { useState } from "react";
import { Button, Modal, Tooltip } from "antd";
import { ShareAltOutlined } from "@ant-design/icons";

import { useDispatch, useSelector } from "react-redux";
import {
  emptyGeneratedHtml,
  generateHtml,
} from "../../actionCreator/webToLeadActionCreater";
import CopyText from "./CopyText";
import { configType } from "../../constant/WebToLead";
import copy from "../../assets/images/webToLead/copy.png";

const Share = ({ formData, isCopy }) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const generatedHtml = useSelector(
    (state) => state.WebToLeadReducer.generatedHtml,
  );
  const loading = useSelector((state) => state.WebToLeadReducer.loading);

  const showModal = () => {
    dispatch(
      generateHtml(
        formData?.id,
        formData.configType === configType.EMBEDDED_SCRIPT,
      ),
    );
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    dispatch(emptyGeneratedHtml());
  };

  return (
    <>
      {isCopy ? (
        <Tooltip title="Copy Code">
          <img
            src={copy}
            alt=""
            style={{
              width: 20,
              height: 20,
            }}
            className="cursor-pointer"
            onClick={showModal}
          />
        </Tooltip>
      ) : (
        <div
          className="heading14px d-flex align-items-center"
          style={{ gap: 10, color: "#29292B", paddingRight: 30 }}
          onClick={showModal}
        >
          <ShareAltOutlined />
          Share
        </div>
      )}
      <Modal
        title={null}
        width={623}
        loading={loading}
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
          {formData?.formName} Code
        </div>
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          <div className="w-100 title">
            <pre
              style={{
                maxHeight: "500px",
                overflow: "scroll",
              }}
            >
              <code style={{ color: "#959595" }}>{generatedHtml}</code>
            </pre>
          </div>
        </div>
        <div className="tw-flex tw-bg-secondary-color tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-4">
          <Button
            className="tw-border-sub-text hover:!tw-border-sub-text tw-text-sm tw-text-sub-text hover:!tw-text-sub-text"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <CopyText
            text={generatedHtml}
            content={
              <Button
                type="primary"
                className="!tw-bg-theme tw-font-medium !tw-outline-0 !tw-border-theme !tw-text-white tw-font-medium tw-text-sm"
              >
                Copy Code
              </Button>
            }
          />
        </div>
      </Modal>
    </>
  );
};

export default Share;
